import { Box, Typography } from '@branch-messenger/willow-ui'
import { FC } from 'react'

type AdvanceConfirmationInfoProps = {
  title: string
  value: string
  valueDescription?: string
}

export const AdvanceConfirmationInfo: FC<AdvanceConfirmationInfoProps> = ({
  title,
  value,
  valueDescription,
}) => (
  <Box
    $display="grid"
    $fullWidth
    style={{
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
    }}
  >
    <Typography $color="textMuted">{title}</Typography>
    <Box $display="flex" $direction="column" $align="initial">
      <Typography $bold>{value}</Typography>
      {valueDescription && (
        <Typography $size="xs" $color="textMuted" $italicized>
          {valueDescription}
        </Typography>
      )}
    </Box>
  </Box>
)
